/* Swubie V2 PDP: gallery slider, price sync on bundle select, testimonial carousel. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---------- Gallery ---------- */
    var track = document.querySelector('.sv2-gallery__track');
    if (track) {
      var slides = track.querySelectorAll('.sv2-gallery__slide');
      var dots = document.querySelectorAll('.sv2-gallery__dot');
      var thumbs = document.querySelectorAll('.sv2-gallery__thumb');
      var current = 0;
      function setActive(i) {
        current = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
      document.querySelectorAll('.sv2-gallery__arrow').forEach(function (a) {
        a.addEventListener('click', function () { goTo(current + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        }, 80);
      });
    }

    /* ---------- Price in the CTA follows the selected bundle ---------- */
    var btn = document.querySelector('.sv2 .slp-offer__atc-btn');
    function syncPrice(bundle) {
      if (!btn || !bundle) return;
      var base = btn.getAttribute('data-cta-base') || (window.SwubieI18n || {}).addToCart || 'In winkelmand';
      var price = bundle.getAttribute('data-price') || '';
      var compare = bundle.getAttribute('data-compare') || '';
      btn.setAttribute('data-cta-text', price ? base + ' · ' + price : base);
      var was = btn.querySelector('.slp-offer__atc-was');
      if (was) was.textContent = compare;
      if (typeof slpUpdateAtcButton === 'function') slpUpdateAtcButton(bundle);
    }
    var initial = document.querySelector('.sv2 .slp-bundle.selected') || document.querySelector('.sv2 .slp-bundle');
    if (initial) syncPrice(initial);
    document.querySelectorAll('.sv2 .slp-bundle').forEach(function (b) {
      b.addEventListener('click', function () { syncPrice(b); });
    });

    /* ---------- Testimonial carousel ---------- */
    document.querySelectorAll('.sv2-tcar').forEach(function (car) {
      var t = car.querySelector('.sv2-tcar__track');
      var cards = t ? t.querySelectorAll('.sv2-tcar__card') : [];
      var dotsWrap = car.querySelector('.sv2-tcar__dots');
      if (!t || !cards.length) return;
      var idx = 0;
      var dotEls = [];
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'sv2-tcar__dot' + (i === 0 ? ' is-active' : ''); d.setAttribute('aria-label', ((window.SwubieI18n || {}).reviewN || 'Beoordeling [n]').replace('[n]', i + 1));
          d.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(d); dotEls.push(d);
        });
      }
      function mark(i) { idx = i; dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
      function go(i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        t.scrollTo({ left: cards[i].offsetLeft - t.offsetLeft, behavior: 'smooth' });
        mark(i);
      }
      car.querySelectorAll('.sv2-tcar__arrow').forEach(function (a) {
        a.addEventListener('click', function () { go(idx + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      var st;
      t.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var step = cards[1] ? (cards[1].offsetLeft - cards[0].offsetLeft) : t.clientWidth;
          var i = Math.round(t.scrollLeft / step);
          if (i !== idx) mark(Math.max(0, Math.min(cards.length - 1, i)));
        }, 80);
      });
    });
  });
})();

/* ---------- Video marquee: play only what is on screen ---------- */
(function () {
  function init() {
    var vids = document.querySelectorAll('.sv2m__video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '0px 80px', threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();


/* ---------- Review bar: fill + count up when it scrolls into view ---------- */
(function () {
  function run(el) {
    if (el.classList.contains('is-in') || el.getAttribute('data-running')) return;
    el.setAttribute('data-running', '1');
    el.getBoundingClientRect();
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
    var label = el.querySelector('.sv2-progress__label');
    var target = parseInt(el.getAttribute('data-pct'), 10);
    if (!label || !target) return;
    var rest = label.textContent.replace(/^\s*\d+/, '');
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var t0 = null, dur = 1800;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 5);
      label.textContent = Math.round(target * eased) + rest;
      if (p < 1) requestAnimationFrame(step);
    }
    label.textContent = '0' + rest;
    requestAnimationFrame(step);
  }
  function init() {
    var bars = document.querySelectorAll('.sv2-progress[data-pct]');
    if (!bars.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    bars.forEach(function (b) { b.classList.add('is-armed'); b.getBoundingClientRect(); });
    if (!('IntersectionObserver' in window)) { bars.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    bars.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
